import {BaseComponent} from "react-vextensions";
import {Observer} from "web-vcore";
import {gql} from "@apollo/client";
import {useSubscription} from "@apollo/client/react";
import {observer} from "mobx-react";
import {observer_mgl} from "mobx-graphlink";

export const LINK_PRESERVER_SUBSCRIPTION = gql`
subscription($input: LinkPreserverInput!) {
	linkPreserver(input: $input) {
		alive
		pageRefreshRequested
	}
}
`;
type LinkPreserverResult = {alive: boolean, pageRefreshRequested: boolean};

export const LinkPreserver = observer_mgl(({}: {})=>{
	// Choose 45s as our update-interval. This works to avoid problems with:
	// 1) Cloudflare's "100 seconds of dormancy" timeout (see: https://community.cloudflare.com/t/cloudflare-websocket-timeout/5865).
	// 2) Nginx's 60s timeout (see: https://stackoverflow.com/questions/10550558 and https://serverfault.com/questions/1060525)
	// 3) The 60s timer-interval that Chrome 88+ allows for hidden pages (see: https://developer.chrome.com/blog/timer-throttling-in-chrome-88/#intensive-throttling).
	// (having this also ensures at least one subscription is always active, preventing Chrome from just closing the websocket itself due to none active -- it *seems* like Chrome has done this at least, eg. on homepage when not signed-in)
	const updateInterval = 45000;

	const {data, loading} = useSubscription(LINK_PRESERVER_SUBSCRIPTION, {
		variables: {input: {updateInterval}},
		onData: info=>{
			const {alive, pageRefreshRequested} = (info.data.data as unknown as {linkPreserver: LinkPreserverResult}).linkPreserver;
			if (pageRefreshRequested) {
				console.log("Refreshing page due to server request.");
				window.location.reload();
			}
		},
	});

	return null;
});